var config = {
  api: {
    host: 'https://staging-api.remoticom.com'
    // host: 'http://rmc2.lightronics.nl'
  },
  socket: {
    host: 'https://staging-api.remoticom.com'
    // host: 'http://rmc2.lightronics.nl'
  },
  externalData: {
    assetDataUrl:'https://zsc-assetsdata.azurewebsites.net/api/device-asset?id='
  },
  maps: {
    accessToken: 'pk.eyJ1IjoicmVtb3RpY29tIiwiYSI6ImNpenNoazRudjAwMnoycWxreXFiNDdyMmsifQ.AaLEI40gfKDqekbGZ0vatA',
    style: 'mapbox://styles/remoticom/ciztmxkh700cs2st6mic3llu8',
    satelliteStyle: 'mapbox://styles/remoticom/cizu0ukj900y72rpdlsypbxtn',
    minZoom: 0,
    maxZoom: 21
  },
  defaultClient: '57b81bb1bb54dd8b6f457f1f',
  tokenHandle: 'remoticom_token'

}

module.exports = config



// WEBPACK FOOTER //
// ./js/configs/staging.config.js